const STORAGE_KEYS = {
  ai: "shiftGame_save_ai",
  passplay: "shiftGame_save_passplay",
};

export function localSaveKeyForCategory(categoryMode) {
  if (categoryMode === "ai") return STORAGE_KEYS.ai;
  if (categoryMode === "Pass & Play" || categoryMode === "passplay") {
    return STORAGE_KEYS.passplay;
  }
  return null;
}

export function isLocalPersistedCategory(categoryMode) {
  return Boolean(localSaveKeyForCategory(categoryMode));
}

export function saveLocalGameSnapshot(categoryMode, snapshot) {
  const key = localSaveKeyForCategory(categoryMode);
  if (!key || !snapshot?.gameState) return;
  try {
    sessionStorage.setItem(key, JSON.stringify(snapshot));
  } catch {
    // ignore quota / private mode
  }
}

export function loadLocalGameSnapshot(categoryMode) {
  const key = localSaveKeyForCategory(categoryMode);
  if (!key) return null;
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.gameState || !Array.isArray(parsed.gameState.board)) return null;
    if (parsed.gameState.board.length !== 9) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearLocalGameSnapshot(categoryMode) {
  const key = localSaveKeyForCategory(categoryMode);
  if (!key) return;
  try {
    sessionStorage.removeItem(key);
  } catch {
    // ignore
  }
}
